// extracted by mini-css-extract-plugin
module.exports = {"vertical":"_93444fe79c--vertical--f5kn6","button-container":"_93444fe79c--button-container--DaUmy","horizontal":"_93444fe79c--horizontal--Tsjvv"};